"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RegularVet = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _DefaultRegularVetDisplaySettings = require("./DefaultRegularVetDisplaySettings");
var _VetPracticesAutoComplete = require("../../components/Forms/FormElements/AutoComplete/VetPractices/VetPracticesAutoComplete");
var _StyledRadios = require("../../components/Forms/FormElements/Radios/StyledRadios/StyledRadios");
var _regularVetDisplaySettingsPropTypes = require("../../propTypes/regularVetDisplaySettingsPropTypes");
var _RegularVetPropTypes = require("./RegularVetPropTypes");
var _FormUtils = require("../../utilities/FormUtils");
require("./regularVet.scss");
const _excluded = ["formContext", "regularVetDisplaySettings", "routeDispatcher", "formId", "regularVetDetails", "globalDispatcher"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const RegularVet = _ref => {
  let {
      formContext,
      regularVetDisplaySettings = _DefaultRegularVetDisplaySettings.DefaultRegularVetDisplaySettings,
      routeDispatcher,
      formId = "regularVetForm_".concat((0, _uuid.v4)().split('-')[0]),
      regularVetDetails,
      globalDispatcher
    } = _ref,
    autoCompleteCustomProps = _objectWithoutProperties(_ref, _excluded);
  const {
    regularVetPanelToggleRadios,
    regularVetInput,
    readonlyMode
  } = regularVetDisplaySettings;
  const regularVet = (0, _react.useMemo)(() => regularVetDetails || _RegularVetPropTypes.emptyVetDetails, [regularVetDetails]);
  const {
    hasRegularVet
  } = regularVet;
  const showRegularVet = hasRegularVet === true;
  const [isShowingForm, setIsShowingForm] = (0, _react.useState)(showRegularVet);
  const readOnlyOverrides = () => {
    if (readonlyMode) {
      return {
        readOnly: true,
        validation: {},
        labelTooltip: null
      };
    }
    return {};
  };
  const handleVetChange = vetDetails => {
    formContext.setValue('regularVet', vetDetails.vet);
    formContext.setValue('regularVetCode', vetDetails.vetNumber);
  };
  const handleRadioChange = value => {
    if (value !== 'yes') {
      formContext.setValue('regularVet', null);
      formContext.setValue('regularVetCode', null);
      setIsShowingForm(false);
    } else {
      setIsShowingForm(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "regularVetForm"
  }, !readonlyMode && /*#__PURE__*/_react.default.createElement(_StyledRadios.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "hasRegularVet",
    value: _FormUtils.formUtils.mapValueToYesNo(hasRegularVet),
    onChange: handleRadioChange
  }, regularVetPanelToggleRadios)), (readonlyMode || isShowingForm) && /*#__PURE__*/_react.default.createElement(_VetPracticesAutoComplete.VetPracticesAutoComplete, _extends({
    fieldFormContext: formContext,
    name: "".concat(formId, "_regularVetFirstName"),
    defaultValue: regularVetDetails && regularVetDetails.vet,
    onSelectWithData: handleVetChange
  }, autoCompleteCustomProps, regularVetInput, readOnlyOverrides())));
};
exports.RegularVet = RegularVet;
RegularVet.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.any,
  regularVetDisplaySettings: _propTypes.default.shape(_regularVetDisplaySettingsPropTypes.RegularVetDisplaySettingsPropTypes),
  routeDispatcher: _propTypes.default.func,
  formId: _propTypes.default.string.isRequired,
  regularVetDetails: _propTypes.default.shape(_RegularVetPropTypes.RegularVetDetailsPropType),
  globalDispatcher: _propTypes.default.func
};
var _default = exports.default = {
  RegularVet
};